import { BreadCrumbPremium } from 'app/components/BreadCrumbPremium';
import LoadPanel from 'app/components/LoadPanel';
import { WrapContent } from 'app/components/WrapContent';
import useAxios from 'axios-hooks';
import { LANG_DEFAULT } from 'constant';
import { router } from 'constant/router';
import { Button, Form } from 'devextreme-react';
import useDictionary from 'hooks/useDictionary';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import tokenService from 'services/auth.service';
import { authenInfoAtom } from 'store/atom-state/authen-atom';
import { notification } from 'utils/notification';
import { valid } from 'utils/validation';

const eye = 'fas fa-eye';
const eyeSlash = 'fas fa-eye-slash';

function ChangePassword() {
  const { t }: any = useDictionary({ programId: 'change-password' });
  const formRef: any = useRef(null);
  const { regexPassword } = valid;
  const history = useHistory();
  const setAuthenInfo = useSetRecoilState(authenInfoAtom);
  const [formData] = useState<any>({
    oldPassword: '',
    password: '',
    confirmPassword: '',
  });
  const [viewPassword, setViewPassword] = useState({
    oldPassword: false,
    password: false,
    conPassword: false,
  });

  const [{ loading }, fetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  const handleSubmit = async () => {
    const isValid = formRef?.current?.instance?.validate()?.isValid;
    if (!isValid) return;

    const res = await fetchData({
      url: '/user-manager/change-password',
      method: 'PUT',
      data: {
        oldPassword: formData.oldPassword || '',
        newPassword: formData.password || '',
      },
    });
    notification({ res });
    if (res?.data?.status === '201') {
      await fetchData({
        url: '/oauth/logout',
        method: 'GET',
      });
      history.push(router.login);
      tokenService.removeToken();
      sessionStorage.clear();
      setAuthenInfo({
        isLoggedIn: false,
        currentUser: {},
        messageLogin: '',
      });
    }
  };

  const passwordRequired: any = o => {
    return {
      type: 'custom',
      validationCallback: (e: any) => {
        const { value } = e;
        if (!value) {
          return false;
        } else if (o && !value) {
          return false;
        } else {
          return true;
        }
      },
      message: t('Password is required'),
    };
  };
  const passwordMatch: any = {
    type: 'custom',
    validationCallback: (e: any) => {
      if (!e?.value) return true;
      const { value } = e;
      if (formData?.password === value) return true;
      return false;
    },
    message: t('The password does not match'),
  };

  const passwordValid = {
    type: 'custom',
    validationCallback: (e: any) => {
      const { value } = e;
      if (!value) return true;
      return regexPassword(value);
    },
    message: t(
      'The password must contain at least 8 characters including number, letter, special character',
    ),
  };

  return (
    <WrapContent>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loading} />
        <BreadCrumbPremium
          title={t('Change Password')}
          // onSubmit={() => validateSave()}
        />
        <div
          style={{ display: 'flex', justifyContent: 'center', marginTop: 60 }}
        >
          <div style={{ width: 500 }}>
            <Form
              formData={formData}
              ref={formRef}
              showColonAfterLabel={false}
              items={[
                {
                  label: { text: t('Old Password') },
                  dataField: 'oldPassword',
                  editorType: 'dxTextBox',
                  editorOptions: {
                    inputAttr: { autoComplete: 'new-password' },
                    mode: viewPassword?.oldPassword ? 'text' : 'password',
                    buttons: [
                      {
                        name: 'view',
                        location: 'after',
                        options: {
                          stylingMode: 'text',
                          icon: viewPassword?.oldPassword ? eye : eyeSlash,
                          onClick: () =>
                            setViewPassword(preState => ({
                              ...preState,
                              oldPassword: !preState.oldPassword,
                            })),
                        },
                      },
                    ],
                  },
                  isRequired: true,
                },
                {
                  label: { text: t('New Password') },
                  dataField: 'password',
                  editorType: 'dxTextBox',
                  editorOptions: {
                    inputAttr: { autoComplete: 'new-password' },
                    mode: viewPassword?.password ? 'text' : 'password',
                    buttons: [
                      {
                        name: 'view',
                        location: 'after',
                        options: {
                          stylingMode: 'text',
                          icon: viewPassword?.password ? eye : eyeSlash,
                          onClick: () =>
                            setViewPassword(preState => ({
                              ...preState,
                              password: !preState.password,
                            })),
                        },
                      },
                    ],
                  },
                  validationRules: [
                    passwordRequired(formData?.confirmPassword),
                    passwordValid,
                    { type: 'required' },
                  ],
                },
                {
                  label: { text: t('Confirm New Password') },
                  dataField: 'confirmPassword',
                  editorType: 'dxTextBox',
                  editorOptions: {
                    mode: viewPassword?.conPassword ? 'text' : 'password',
                    buttons: [
                      {
                        name: 'view',
                        location: 'after',
                        options: {
                          stylingMode: 'text',
                          icon: viewPassword?.conPassword ? eye : eyeSlash,
                          onClick: () =>
                            setViewPassword(preState => ({
                              ...preState,
                              conPassword: !preState.conPassword,
                            })),
                        },
                      },
                    ],
                  },
                  validationRules: [
                    passwordRequired(formData?.password),
                    passwordValid,
                    passwordMatch,
                  ],
                  isRequired: true,
                },
              ]}
              labelLocation="top"
              colCount={1}
            ></Form>
            <div style={{ marginTop: 20 }}>
              <Button
                stylingMode="contained"
                type="default"
                text={t('Save Changes')}
                style={{ marginRight: 5, width: '100%' }}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      </React.Suspense>
    </WrapContent>
  );
}

export default ChangePassword;
